import { compose } from 'recompose';
import { prop } from 'ramda';

import CreateProjectModal from './createProjectModal';
import withCRUDProject from '../../../../../utils/enchancers/withCRUDProject';
import rules from '../rules';

const enhance = compose(
  withCRUDProject({
    rules,
    data: () => null,
    modalName: 'createProjectModal',
    onSubmit: (formValues, {
      resetForm, props: {
        addProject, setCloseModal, goToProject, initialValues,
      },
    }) => {
      const data = ({
        ...formValues,
        type: Number(formValues.type),
        members: formValues.members.map(prop('value')),
        client_id: formValues.client_id.value || null,
      });
      addProject(data, {
        callbacks: {
          success: ({ project: { id } }) => {
            resetForm(initialValues);
            setCloseModal('createProjectModal');
            goToProject(`/projects/${id}/`);
          },
        },
      });
    },
  }),
);

export default enhance(CreateProjectModal);
